import { baseCabinet1Drawer2DoorsComponents } from './base-cabinet-1-drawer-2-doors.js';
import { baseCabinet2DoorComponents } from './base-cabinet-2-door.js';
import { baseCabinet3DrawerComponents } from './base-cabinet-3-drawer.js';
import { baseCabinet4DrawerComponents } from './base-cabinet-4-drawer.js';
import { baseCabinetComponents } from './base-cabinet.js';
import { cabinetComponents } from './cabinet.js';
import { countertopComponents } from './countertop.js';
import { emptySpaceComponents } from './empty-space.js';
import { noCabinetComponents } from './no-cabinet.js';
import { nonWallCabinetSegmentComponents } from './non-wall-cabinet-segment.js';
import { sceneComponents } from './scene.js';
import { segmentComponents } from './segment.js';
import { tallCabinet24Components } from './tall-cabinet-24.js';
import { tallCabinet36Components } from './tall-cabinet-36.js';
import { wallCabinetComponents } from './wall-cabinet.js';
export const generatedComponents = [
    ...sceneComponents,
    ...baseCabinetComponents,
    ...baseCabinet1Drawer2DoorsComponents,
    ...baseCabinet2DoorComponents,
    ...baseCabinet3DrawerComponents,
    ...baseCabinet4DrawerComponents,
    ...cabinetComponents,
    ...countertopComponents,
    ...emptySpaceComponents,
    ...noCabinetComponents,
    ...nonWallCabinetSegmentComponents,
    ...segmentComponents,
    ...tallCabinet24Components,
    ...tallCabinet36Components,
    ...wallCabinetComponents
];

//# sourceMappingURL=index.js.map